<div class="tw-flex tw-flex-col tw-justify-center tw-h-full tw-text-sm tw-text-dt-text-headings">
  <div class="tw-flex tw-items-center tw-font-medium tw-text-[13px]">
    @if (description === alignBalReset) {
      <div class="tw-font-normal tw-gap-1">
        <span class="tw-text-blue-700 tw-shrink-0">Align.</span>
        <span class="tw-text-dt-text-secondary">Balance Reset</span>
      </div>
    } @else if (description.includes(revaluation)) {
      <div class="tw-font-normal tw-gap-1">
        <span class="tw-text-orange-500 tw-shrink-0">Reval.</span>
        <span class="tw-text-dt-text-tertiary">{{ description.replace(revaluation, "") }}</span>
      </div>
    } @else {
      @if (status === "pending") {
        <span
          class="tw-inline-flex tw-h-[14px] tw-w-[14px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[7px] tw-bg-[green] tw-text-[10px] tw-leading-none tw-text-dt-text-contrast"
          >P</span
        >
      }
      @if (linkType) {
        <app-link-type-badge class="tw-mr-1.5" [type]="linkType"></app-link-type-badge>
      }
      <span
        class="tw-text-[14px]"
        data-testid="transaction-description"
        [ngClass]="linkType ? 'tw-font-normal tw-text-dt-text-tertiary' : 'tw-font-medium'"
        >{{ description }}</span
      >
    }
  </div>
  <span
    class="tw-text-[13px]"
    [ngClass]="{
      'tw-text-dt-text-disabled':
        description.includes(alignment) || description.includes(revaluation),
    }"
  >
    {{ date }}
  </span>
</div>
